module.exports = __webpack_public_path__ + "static/media/ic_feed_big_preview.23fc200d.svg";